// Wrapper fino sobre las Cloud Functions de listas/favoritos (Postgres/Neon).
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const listarListasFn = httpsCallable(functions, 'listarListas');
const crearListaFn = httpsCallable(functions, 'crearLista');
const actualizarListaFn = httpsCallable(functions, 'actualizarLista');
const eliminarListaFn = httpsCallable(functions, 'eliminarLista');
const obtenerListaFn = httpsCallable(functions, 'obtenerLista');
const agregarAutoALisFn = httpsCallable(functions, 'agregarAutoALista');
const quitarAutoDeListaFn = httpsCallable(functions, 'quitarAutoDeLista');
const agregarSeguimientoPrecioFn = httpsCallable(functions, 'agregarSeguimientoPrecio');
const eliminarSeguimientoPrecioFn = httpsCallable(functions, 'eliminarSeguimientoPrecio');
const guardarSubcategoriaProyectoFn = httpsCallable(functions, 'guardarSubcategoriaProyecto');
const consultarProyectoIAFn = httpsCallable(functions, 'consultarProyectoIA', { timeout: 170000 });
const listarHistorialIAProyectoFn = httpsCallable(functions, 'listarHistorialIAProyecto');

export async function listarListas() {
  const result = await listarListasFn();
  return result.data.listas;
}

export async function crearLista(nombre, descripcion) {
  const result = await crearListaFn({ nombre, descripcion });
  return result.data.lista;
}

export async function actualizarLista(id, nombre, descripcion) {
  await actualizarListaFn({ id, nombre, descripcion });
}

export async function eliminarLista(id) {
  await eliminarListaFn({ id });
}

export async function obtenerLista(id) {
  const result = await obtenerListaFn({ id });
  // { lista, autos, seguimiento: { [vehicleVersionId]: [{id,tipoPrecio,precio,fecha,nota}] },
  //   subcategorias: { [vehicleVersionId]: texto },
  //   competidores: { [vehicleVersionId]: [{vehicleVersionId,marca,model,modelDetail,origen}] },
  //   alertConfig: { [vehicleVersionId]: {umbralPrecioPct,alertarNuevasVersiones,alertarDescontinuados,alertarFinanciamiento} } }
  return result.data;
}

// Subcategoría manual por proyecto — privada de ESTE proyecto, no toca vehicle_versions.
export async function guardarSubcategoriaProyecto(listaId, vehicleVersionId, subcategoria) {
  const result = await guardarSubcategoriaProyectoFn({ listaId, vehicleVersionId, subcategoria });
  return result.data.subcategoria;
}

// Seguimiento de precios manual — privado del proyecto, no toca los datos generales.
export async function agregarSeguimientoPrecio(listaId, vehicleVersionId, tipoPrecio, precio, fecha, nota) {
  const result = await agregarSeguimientoPrecioFn({ listaId, vehicleVersionId, tipoPrecio, precio, fecha, nota });
  return result.data.entrada;
}

export async function eliminarSeguimientoPrecio(id) {
  await eliminarSeguimientoPrecioFn({ id });
}

// IA con contexto del proyecto (modelos del proyecto + mercado en general +
// modelos que se mencionen en la pregunta). historial: [{role,content}] de
// intercambios previos, para seguimiento conversacional.
export async function consultarProyectoIA(listaId, prompt, historial) {
  const result = await consultarProyectoIAFn({ listaId, prompt, historial });
  return result.data; // { response, model, latencyMs, usage, createdAt }
}

// Historial persistido de preguntas/respuestas de este proyecto.
export async function listarHistorialIAProyecto(listaId) {
  const result = await listarHistorialIAProyectoFn({ listaId });
  return result.data.historial; // [{id, prompt, response, createdAt}]
}

export async function agregarAutoALista(listaId, marca, model, modelDetail) {
  await agregarAutoALisFn({ listaId, marca, model, modelDetail });
}

export async function quitarAutoDeLista(listaId, marca, model, modelDetail) {
  await quitarAutoDeListaFn({ listaId, marca, model, modelDetail });
}
